/**
 * 宿泊施設のドロップボックス
 *
 * Copyright (c) 2018-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const RoomOptionsState = Record({
  options: [],
  isLoading: true
})

export { RoomOptionsState }
